<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="manualDippingService.loading$"
	[confirmButtonText]="'gl.delete'"
	size="md"
	class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ 'manual_dipping.removingDialogTitle' | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			{{ 'manual_dipping.removingDialog' | translate }}
			<strong>DD-{{ data.mdTask.mdTaskID }}</strong>
		</p>
	</div>
</alaris-dialog>
